export const WEDDING_DATE = "Sept. 18th, 2025";

export const PHOTO_URLS = {
  GUEST: "images/cover-photo.jpg",
  ADMIN: "",
} as const;

export const NAVIGATION_LINKS = [
  { href: "#", label: "Registry" },
  { href: "#", label: "Registry" },
  { href: "#", label: "Registry" },
] as const;
